import { PendingOrderType } from './pending-order-type';
import { ToolCategory } from './tool-category';

export class PendingOrder {

  constructor(
    public name?: string,
    public reference?: string,
    public isHolder?: boolean,
    public stock?: number,
    public orderQuantity?: number,
    public validationQuantity?: number,
    public pendingOrderType?: PendingOrderType,
    public toolCategory?: ToolCategory,
  ) { }

  get toolCategoryName() {
    return this.toolCategory ? this.toolCategory.name : null;
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/pending-order.ts